import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { SimilarAds } from '../SimilarAds'
import { Images } from '../Images'

export const Content = ({page, onImagesClosed}) => {
  const { t } = useTranslation('common')

  let Component = null
  let props = {}
  switch (page) {
    case 'similarAds': Component = SimilarAds; break
    case 'images':
      Component = Images
      props = {onLightboxClosed: onImagesClosed}
      break
    // case 'registration': Component = ...; break
    default: break
  }
  return <div className='oglasi-tab-content'>
    {Component ? <Component {...props} /> : <h1 style={{marginLeft: '50%', color: 'lightgray'}}>{t('USKORO')}</h1>}
  </div>
}

Content.propTypes = {
  page: PropTypes.string.isRequired,
  onImagesClosed: PropTypes.func
}
